var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9519 1.04809C17.5543 -0.349425 15.2885 -0.349355 13.8911 1.04824L1.94103 12.9997C1.5347 13.4061 1.2491 13.9172 1.116 14.4763L0.0204088 19.0777C-0.0399112 19.3311 0.0355188 19.5976 0.219679 19.7818C0.403849 19.9659 0.670369 20.0414 0.923729 19.981L5.52498 18.8855C6.08418 18.7524 6.59546 18.4666 7.00191 18.0601L16.9995 8.06137C17.6777 8.74517 17.676 9.84937 16.9943 10.5311L15.2109 12.3145C14.918 12.6074 14.918 13.0822 15.2109 13.3751C15.5038 13.668 15.9786 13.668 16.2715 13.3751L18.055 11.5917C19.3224 10.3243 19.3242 8.27028 18.0601 7.00065L18.952 6.1086C20.3493 4.71112 20.3493 2.44551 18.9519 1.04809ZM14.9518 2.10884C15.7634 1.29708 17.0795 1.29704 17.8912 2.10875C18.7028 2.92039 18.7029 4.23632 17.8913 5.04802L5.94119 16.9995C5.73104 17.2097 5.46668 17.3574 5.17755 17.4263L1.76191 18.2395L2.57521 14.8237C2.64402 14.5347 2.79168 14.2704 3.00175 14.0603L14.9518 2.10884Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperation);
export default __webpack_public_path__ + "static/media/operation.6b317a21ae3ca3b2249c2a3502e52b38.svg";
export { ForwardRef as ReactComponent };